import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { UserPlus, Check, X } from "lucide-react";
import { toast } from "sonner";
import { api, rp } from "@/lib/api";
import { logError } from "@/lib/log";

export const AccountLinkQueue = () => {
  const [rows, setRows] = useState([]);
  const load = () => api.get("/account-links", { params: { status: "pending" } })
    .then((r) => setRows(r.data)).catch((e) => logError("Account links failed", e));
  useEffect(() => { load(); }, []);

  const act = async (id, what) => {
    try {
      await api.post(`/account-links/${id}/${what}`, {});
      toast.success(what === "approve" ? "Akun member terhubung" : "Permintaan ditolak");
      load();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Failed");
    }
  };

  if (rows.length === 0) return null;
  return (
    <div className="mt-5 rounded-lg border border-amber-300 bg-amber-50 p-4" data-testid="account-link-queue">
      <div className="flex items-center gap-2 text-sm font-semibold text-amber-900">
        <UserPlus size={16} /> Permintaan Hubungkan Akun Member ({rows.length})
      </div>
      <p className="mt-1 text-xs text-amber-900/80">
        Akun Member memakai nomor WhatsApp yang sudah punya riwayat sewa. Setujui hanya kalau nomor dan nama cocok.
      </p>
      <div className="mt-3 space-y-2">
        {rows.map((l) => (
          <div key={l.id} className="bg-white rounded-md border border-black/10 p-3 flex flex-wrap items-center gap-3 text-sm"
            data-testid={`link-row-${l.id}`}>
            <div className="min-w-0 flex-1">
              <div className="font-medium">{l.member_email}</div>
              <div className="text-xs text-ink-soft mt-0.5">
                {l.whatsapp} → <Link to="/admin/customers" className="text-lm-red">{l.customer_name}</Link>
                {" · "}{l.customer_no} · {l.customer_rentals}x sewa · {rp(l.customer_spending)} · {l.customer_tier}
              </div>
            </div>
            <button data-testid={`link-approve-${l.id}`} onClick={() => act(l.id, "approve")}
              className="h-9 px-3 rounded-md bg-ink text-cream text-xs flex items-center gap-1.5 hover:bg-lm-red">
              <Check size={14} /> Setujui
            </button>
            <button data-testid={`link-reject-${l.id}`} onClick={() => act(l.id, "reject")}
              className="h-9 px-3 rounded-md border border-black/15 text-xs flex items-center gap-1.5 hover:border-lm-red">
              <X size={14} /> Tolak
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};
